import React, { useState, useRef } from 'react';
// import { Button } from './Button';
import { Link, useLocation } from 'react-router-dom';

import './style.css';

function Menubar() {
  const location = useLocation();
  const navRef = useRef(null)

  const clearLocalStorage = () => {
    localStorage.clear();
  }

  const [click, setClick] = useState(false);

  const role = JSON.parse(localStorage.getItem("admin-info")).role;


  const [links, setLinks] = useState([
    {
      path: "organizations",
      label: "Organizations",
      type: "both",
      role: [1, 3],
    },

    {
      path: "ambassadors",
      label: "Ambassadors",
      type: "both",
      role: [1, 3],
    },

    {
      path: "super-users",
      label: "Super Users",
      type: "both",
      role: [1, 3],
    },

    {
      path: "users",
      label: "Users",
      type: "both",
      role: [1, 3, 4],
    },

    {
      path: "notifications",
      label: "Notifications",
      type: "both",
      role: [1, 3],
    },

    {
      path: "embeddings",
      label: "Embeddings",
      type: "both",
      role: [1, 3],
    },

    {
      path: "login",
      label: "Logout",
      type: "both",
      callback: () => {
        clearLocalStorage();
      },
      role: [1, 3, 4],
    },

  ]);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const SetSubmenuStatus = (ind, bool) => {
    var tempLinks = [...links];
    tempLinks[ind] = {
      ...tempLinks[ind],
      openSubMenu: !tempLinks[ind].openSubMenu,
    }
    setLinks(tempLinks);
  }


  return (
    <div id="custom-menu-bar">
      {
        click
          ? <div
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
              zIndex: 4
            }}
            onClick={handleClick}
          ></div>
          : ""
      }



      <header>

        <nav className='navbar' ref={navRef}>
          <Link className="navbar-brand" to="/">
            <img src="/assets/images/logo.png" alt="Brand" className="logo" />
          </Link>


          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            {
              links.map((link, i) => {

                let isActiveLink = location.pathname.includes("/" + link.path);
                return (link.role.includes(role)) ? (
                  <li className='nav-item' key={"menu-link-" + i}>
                    <Link to={'/' + link.path} className={'nav-links' + (link.sub ? " w-sub-nav" : "") + (isActiveLink ? " active-link" : "")} onClick={(e) => {

                      if (link.hasOwnProperty("callback")) {
                        link.callback();
                      }

                      if (!link.sub) {
                        closeMobileMenu();

                        setLinks(links.map((l, i3) => {
                          return {
                            ...l,
                            openSubMenu: false
                          }
                        }));

                      } else {
                        e.preventDefault();

                        SetSubmenuStatus(i);
                      }
                    }}>
                      <h5>{link?.label?.toUpperCase()}</h5>
                    </Link>
                    {
                      link.sub && link.openSubMenu
                        ?
                        <ul className="sub-nav">
                          {
                            link.sub.map((sublink, i2) => {
                              let isActiveLink2 = location.pathname.includes("/" + sublink.path);

                              return (
                                <Link to={'/' + sublink.path} className={'nav-links' + (isActiveLink2 ? " active-link" : "")} onClick={(e) => {
                                  if (sublink.hasOwnProperty("callback")) {
                                    sublink.callback();
                                  }

                                  closeMobileMenu();
                                  SetSubmenuStatus(i);
                                }} key={"menu-sublink-" + i2}>
                                  {sublink.label}
                                </Link>
                              )
                            })
                          }
                        </ul>

                        : ""
                    }

                  </li>

                ) : ""
              })
            }

          </ul>
        </nav>
      </header>

    </div>
  )
}

export default Menubar; 